import UPTab from 'components/tab';
import { UPTabSection } from 'components/tab/types';
import { SectionContainer } from 'modules/companies/styles';
import ParitairComite from 'modules/paritair-comite';
import WageComponents from 'modules/payroll-settings/WageComponents';
import WageIndexation from 'modules/payroll-settings/wage-indexation/WageIndexation';
import { useTranslation } from 'react-i18next';
import {
  MENU__PARITAIR_COMITE,
  PAYROLL_SETTINGS__WAGE_COMPONENTS,
  PAYROLL_SETTINGS__WAGE_INDEXATION,
} from 'translations/constants';
import { JointCommissionsTab } from './routes';
import { JointCommissionsBody, JointCommissionsContainer } from './styles';

/**
 * "Joint commissions" configuration domain: the three screens that were the entire content of the
 * old Payroll settings section, relocated unchanged.
 * The components themselves stay in `modules/paritair-comite` and `modules/payroll-settings` — the
 * relocation is of the routes and the navigation, so no screen's own code changes.
 */
const JointCommissions = (): JSX.Element => {
  const [t] = useTranslation();

  const sections: UPTabSection[] = [
    { title: t(MENU__PARITAIR_COMITE), route: JointCommissionsTab.PARITAIR_COMITE },
    { title: t(PAYROLL_SETTINGS__WAGE_COMPONENTS), route: JointCommissionsTab.WAGE_COMPONENTS },
    { title: t(PAYROLL_SETTINGS__WAGE_INDEXATION), route: JointCommissionsTab.WAGE_INDEXATION },
  ];

  return (
    <JointCommissionsContainer>
      <JointCommissionsBody>
        <UPTab sections={sections}>
          <ParitairComite />
          <WageComponents />
          <SectionContainer>
            <WageIndexation />
          </SectionContainer>
        </UPTab>
      </JointCommissionsBody>
    </JointCommissionsContainer>
  );
};

export default JointCommissions;
